// extracted by mini-css-extract-plugin
module.exports = {"skeletonItem":"RecentReadingSessionsSkeleton_skeletonItem__73ehH"};